iScreenWizard.controller('P2CIdeaalscoresController', function ($scope, $state, $mdDialog, $filter, Ajax, Dictionary, ErrorHandler, userService, p2cService) {

    $scope.userService = userService;
    $scope.p2c = p2cService.model;

    $scope.competentieprofielen = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        params = {
            _method: 'get_ideaalscore_data_testafnames',
            intellectuele_competentie_optie: p2cService.model.intellectuele_competentie_optie,
            testafname_ids: []
        };
        if (p2cService.model.intellectuele_competentie_optie != 3) {
            params.competentieprofiel_id = p2cService.model.competentieprofiel.id;
        } else {
            params.opleidingsgroep_id = p2cService.model.opleidingsgroep_id;
        }
        angular.forEach(p2cService.model.testafnames, function(testafname) {
            params.testafname_ids.push(testafname.id);
        });
        if (p2cService.model.matching_session_id) {
            params.matching_session_id = p2cService.model.matching_session_id;
        }
        Ajax.post('matching', params).then(function(response) {
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                p2cService.model.matching_session_id = response.data.matching_session_id;
                p2cService.SaveState();
                $scope.competentieprofielen = response.data.competentieprofielen;
            }
        });
    };
    $scope.refresh = refresh;

    $scope.resetIdeaalscores = function(competentieprofiel) {
        angular.forEach(competentieprofiel.competentietypes, function(competentietype) {
            angular.forEach(competentietype.competenties, function(competentie) {
                competentie.min_ideaalscore_aangepast = competentie.min_ideaalscore_profiel;
                competentie.max_ideaalscore_aangepast = competentie.max_ideaalscore_profiel;
            });
        });
    };

    $scope.match = function() {
        p2cService.model.competentieprofielen = $scope.competentieprofielen;
        p2cService.SaveState();
        $state.go('matching/p2c/resultaten');
    };

});